import {NullAsDefault} from "views/Shared";
import {connect} from 'react-redux'
import {branch, compose} from 'recompose'
import {getLogin} from 'redux/selectors'

export const createRequiredNonLogin = (
  FallBackComponent = NullAsDefault
) =>
  compose(
    connect(state => ({
      login: !!getLogin(state)
    })),
    branch(
      props => props.login,
      () => FallBackComponent
    )
  )
